import React, { useMemo } from "react";
import { Box } from "@mui/material";

import { useStackedNavigationContext } from "fond/widgets";
import StackedNavigationHeader from "fond/widgets/StackedNavigation/StackedNavigationHeader";

import { LayerPanelContext } from "./LayerPanelContext";

interface LayerPanelProps {
  title: string;
  layerKey: string;
  /** The panel's actions and any layer-specific content. */
  children?: React.ReactNode;
}

const LayerPanel: React.FC<LayerPanelProps> = ({ title, layerKey, children }) => {
  const { clear } = useStackedNavigationContext();
  const context = useMemo(() => ({ title, layerKey }), [title, layerKey]);

  return (
    <LayerPanelContext.Provider value={context}>
      <Box>
        <StackedNavigationHeader title={title} onBackButtonClick={clear} />
        {children}
      </Box>
    </LayerPanelContext.Provider>
  );
};

export default LayerPanel;
